import React from 'react';
import { motion } from 'framer-motion';
import { HeartHandshakeIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 lg:py-24 bg-[var(--color-pale-pink)]" data-id="element-70">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center" data-id="element-72">
          <div className="bg-white rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-73">
            <HeartHandshakeIcon className="w-10 h-10 text-[var(--color-dark-sage)]" strokeWidth={1.5} data-id="element-74" />
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-[var(--color-charcoal)] mb-6" data-id="element-75">
            Tu satisfacción es nuestra prioridad
          </h2>
          <p className="text-lg lg:text-xl text-[var(--color-charcoal)] font-light leading-relaxed" data-id="element-76">
            Queremos que vivas la mejor experiencia posible. Si tienes dudas o
            necesitas orientación para aprovechar la guía al máximo, escríbenos
            a support@upreferr.com y te acompañamos personalmente.
          </p>
        </motion.div>
      </div>
    </section>;
}